export enum Module {
  SMART_REPORTING = 'smart_reporting',
  SURVEY = 'survey',
  CHILD_PROJECTS = 'child_projects',
  WFS = 'wfs',
}
